import React, { useMemo } from "react";
import styles from "@/containers/project-screen/project.module.scss";
import sharedStyles from "@/components/Listing/ListingScreen/.module.scss";
import Image from "next/image";

const FacilitiesSection = ({ facilities }) => {
  const [collapsed, setCollapsed] = React.useState(true);

  const limit = useMemo(
    () => (collapsed ? 6 : facilities.length),
    [collapsed, facilities],
  );

  return (
    !!facilities?.length && (
      <div
        className={`${styles.facilitiesSection} ${sharedStyles.card} ${sharedStyles.bottomBorderOnly} ${sharedStyles.flex}`}
      >
        <div className={styles.title}>
          <h4>مميزات المشروع</h4>
          {!(!collapsed || facilities.length <= 6) && (
            <span
              onClick={() => setCollapsed(false)}
              className={styles.showMore}
            >
              عرض الكل
            </span>
          )}
        </div>
        <div className={styles.facilitiesList}>
          {facilities.slice(0, limit).map((facility, index) => (
            <div key={index} className={styles.facilityItem}>
              <Image
                src={facility.icon_url_svg}
                width={36}
                height={36}
                alt={facility.meta_key_name?.ar}
              />
              <span className={styles.label}>{facility.meta_key_name?.ar}</span>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default FacilitiesSection;
